import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function consoleAccessoryList(
  console_id: string,
  query?: QueryType,
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `admin/console/${console_id}/accessory/list${queryString}`,
  );
}

export async function consoleAccessoryConsoleList(
  accessory_id: string,
  query?: QueryType,
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `admin/console/accessory/${accessory_id}/console/list${queryString}`,
  );
}

export async function consoleAccessoryListId(console_id: string) {
  return await clientAxios.get(`admin/console/${console_id}/accessory/list/id`);
}

export async function consoleAccessoryListConsoleIdByAccessory(
  accessory_id: string,
) {
  return await clientAxios.get(
    `admin/console/accessory/${accessory_id}/list/id`,
  );
}

export async function consoleAccessoryGet(item_id: string) {
  return await clientAxios.get(`admin/console/accessory/${item_id}/show`);
}

export async function consoleAccessoryCreate(
  console_id: string,
  payload: Partial<any>,
) {
  return await clientAxios.post(
    `admin/console/${console_id}/accessory/create`,
    payload,
  );
}

export async function consoleAccessoryDelete(item_id: string) {
  return await clientAxios.del(`admin/console/accessory/${item_id}/delete`);
}
